import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import {Link} from "react-router-dom";
import Dashboard from "../../../components/common/dashboard/Dashboard";
import {useEffect, useState} from "react";
import {getCADList} from "../../../api/admin/cadReq";
import useAuth from "../../../hooks/useAuth";
import {cadOrder} from "../../../helper/orders";
import usePager from "../../../hooks/usePager";

export default function CADTemplates() {
    const { auth } = useAuth();
    const token = auth.token;
    const tabSource = "fa fa-bars";
    const [cadList, setCADList] = useState();
    const { itemsPerPage, currentPage, setCurrentPage, setTotalPages } = usePager();
    const [totalItems, setTotalItems] = useState();

    const apiCADList  = async () => {
        const response = await getCADList(token, currentPage, itemsPerPage);
        setCADList(response?.cadList);
        setTotalItems(response?.totalItems);
        setTotalPages(Math.ceil((response?.totalItems || 0) / itemsPerPage))
    }

    useEffect(() => {
        setCurrentPage(1)
    }, [ itemsPerPage ]);

    useEffect(() => {
        apiCADList();
    }, [ token, currentPage, itemsPerPage ]);

    return (
        <main className="admin">
            <Header
                parent="Administration"
                location="Courriers"
            />
            <div>
                <nav className="tabs-menu">
                    <ul>
                        <li><Link to="/admin/documents">Voir les documents</Link></li>
                        <li className="active" ><Link to="/admin/documents/courriers">Gérer les courriers</Link></li>
                        <li><Link to="/admin/documents/devis/section/1/voir">Voir les devis type</Link></li>
                        <li><Link to="/admin/documents/devis/categories">Gérer les catégories</Link></li>
                    </ul>
                </nav>
                <div className="content-container">
                    <Icon span="Gestion des courriers après décès" source="fa fa-file-lines" />
                    <div className="dashboard">
                        <Dashboard totalItems={totalItems} apiCADList={apiCADList} location="Courriers après décès" dataObject={ cadList || [] } order={ cadOrder } />
                    </div>
                </div>

            </div>
        </main>
    )
}